<template>
  <div class="findlawyer-order">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <!-- <Header title="支付订单" :need-seo="false" /> -->
    <div class="findlawyer-order-header background-white">
      <div class="title">
        {{payInfo.serviceName}}服务信息
      </div>
      <div class="price">
        <div class="flex van-hairline--bottom pd-bm-10">
          <img :src="config.icon" alt="">
          <div class="flex flex-column flex-space-center mg-l-10">
            <span class="font16" style="font-weight:bold">{{ payInfo.serviceName }}</span>
            <span class="mg2 font12" style="color:#8A8D94">{{config.text || '123'}}</span>
          </div>
        </div>
        <div class="flex flex-space-between flex-align-end ">
          <div class="font22 flex flex-align-center mg-tp-12" style="color:#EC5050">
            <span class="font14">￥</span>
            <span>{{ payInfo.servicePrice/100 }}</span>
            <span v-if="payInfo.originalPrice" class="font12 mg-l-15 origin-price" style="color:#8A8D94">原价￥{{ payInfo.originalPrice/100 }}</span>
          </div>
          <div class="font11 timer">
            {{payInfo.serviceCode==='CASE_ENTRUSTMENT'?'次数':'时长'}}：{{ payInfo.showServiceLength }}{{payInfo.serviceLengthUnit==='分'?'分钟':payInfo.serviceLengthUnit}}
          </div>
        </div>
      </div>
    </div>
    <div class="pay-type pd-rt-16 pd-lt-16 background-white">
      <div class="line font15 flex flex-align-center">
        请选择支付方式
      </div>
      <div v-for="(i,index) in payType" :key="index" class="typeline flex flex-space-between flex-align-center" @click="hasOrderPayQuery.payType=i.value">
        <img :src="i.icon">
        <p class="flex-1">
          {{ i.label }}
        </p>
        <img v-if="hasOrderPayQuery.payType===i.value" class="check" src="@/assets/imgs/common/check_circle@2x.png">
      </div>
      <div class="tips">
        温馨提示：<br>
        咨询中遇到问题，可在 我的-意见反馈中进行反馈。<br>
        咨询订单如有疑问，可以拨打官网热线 400-6030452<br>
      </div>
    </div>
    <div class="fixed-wrap">
      <div class="bt" @click="submitPay">
        立即支付
      </div>
      <div class="protocol">
        <van-checkbox v-model="checked" checked-color="#2485FF" icon-size="15px" shape="square" >
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-checkbox>
        <p>
          支付成功则默认同意 <a :href="protocols.law_buy_protocol">《咨询服务产品》</a>协议
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar,Icon } from 'vant';
// import Header from '@/components/business/headers'
import { Checkbox } from 'vant'
import {  speedOrderGoPay, speedOrderDetail, homeServicePriceList } from '@/api/speedOrder'
import { protocols } from '@/libs/config'
import { callApp } from "@/libs/bridge";
import { buriedChannelPoint } from '@/api/common'
import { POINT_CODE, BURY_POINT_TYPE, BEHAVIOR } from '@/libs/config'

export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar,
    'van-checkbox': Checkbox
  },
  data() {
    return {
      activeIcon:require('@/assets/imgs/common/check.png'),
      inactiveIcon:require('@/assets/imgs/common/incheck.png'),
      protocols,
      /** 已有订单去支付 */
      hasOrderPayQuery: {
        /* 业务订单id*/
        orderId: '',
        /* 业务订单orderNo为了处理重新购买 后端 只能带过来orderNo*/
        orderNo: '',
        payType: '2', /* 支付类型[1:支付宝,2:微信]*/
      },
      /** 支付详情数据 */
      payInfo: {
        "serviceName":'图文咨询',
        "serviceCode":'ONE_TO_ONE',
        "servicePrice" : 123,
        "originalPrice" : 0,
        "serviceLengthUnit" : "小时",
        "showServiceLength" : 12
      },
      serverData:{},
      /* 协议*/
      checked: true,
      /* 支付类型*/
      payType: [{
        label: '微信支付',
        value: '2',
        icon: require('@/assets/imgs/common/icon_wepay@2x.png')
      }]
    }
  },
  computed:{
    config(){
      return {
        'QUICK_CONSULT':{
          text:'从业年限3年以上，平均1分钟响应',
          icon:require('@/assets/imgs/common/order3.png')
        },
        'TELEPHONE_CONSULTING':{
          text:'极速响应高效沟通，服务时间内多轮通话',
          code:POINT_CODE.ZSFW_DHZX_DDQR_LJZX_BUTTON,
          icon:require('@/assets/imgs/common/order6.png')
        },
        'CASE_ENTRUSTMENT':{
          text:'平台提供保障，对接专业律师律师1V1服务',
          icon:require('@/assets/imgs/common/order5.png')
        },
        'ONE_TO_ONE':{
          text:'不限次数文字、图文沟通，有效期12小时',
          code:POINT_CODE['1V1_TWZX_LJZX_BUTTON'],
          icon:require('@/assets/imgs/common/order4.png')
        },
        'ONE_TO_ONE_TEL':{
          text:'极速响应高效沟通，服务时间内多轮通话',
          code:POINT_CODE['1V1_DHZX_LJZX_BUTTON'],
          icon:require('@/assets/imgs/common/order6.png')
        }
      }[this.payInfo.serviceCode] || {}
    }
  },
  async mounted() {
    window.physicsBackFn = this.back
    // buryPointChannelBasics({
    //   code: POINT_CODE.PUBLIC_PAY_PAY_PAGE, // 1.5.1极速咨询支付页访问
    //   type: 1, // 页面事件
    //   behavior: BURY_POINT_CHANNEL_TYPE.CA
    // })
    /* 有订单 直接支付 不用生成订单*/
    // const { orderId, orderNo } = this.$route.query
    // consultType 2 一对一图文咨询   5 一对一电话咨询
    const { orderId, price, consultType, serviceLengthUnit, showServiceLength } = this.$route.query
    if(consultType){
      if(consultType==='2'||consultType==='5'){
        window.localStorage.setItem('price', price)
        window.localStorage.setItem('consultType', consultType)
        window.localStorage.setItem('serviceLengthUnit', serviceLengthUnit)
        window.localStorage.setItem('showServiceLength', showServiceLength)
      }else{
        window.localStorage.removeItem('price')
        window.localStorage.removeItem('consultType')
        window.localStorage.removeItem('serviceLengthUnit')
        window.localStorage.removeItem('showServiceLength')
      }
    }

    this.hasOrderPayQuery.orderId = orderId ? orderId : ''
    if(orderId&&!price){
      this.getSpeedOrderDetail(this.hasOrderPayQuery)
    }else if(price){
      // 一对一 不能通过订单查询 时间写死12小时 价格拿参数获取
      if(consultType==='2'){
        this.payInfo = {
          "serviceName":'图文咨询',
          "serviceCode":'ONE_TO_ONE',
          "servicePrice" : price,
          "originalPrice" : 0,
          "serviceLengthUnit" : serviceLengthUnit||"小时",
          "showServiceLength" : showServiceLength||12
        }
      }else if(consultType==='5'){
        this.payInfo = {
          "serviceName":'一对一电话咨询',
          "serviceCode":'ONE_TO_ONE_TEL',
          "servicePrice" : price,
          "originalPrice" : 0,
          "serviceLengthUnit" : serviceLengthUnit||"小时",
          "showServiceLength" : showServiceLength||12
        }
      }
    }else{
      this.$toast('暂无此订单')
    }
  },
  methods: {
    back(){
      callApp('finishActivity')
    },
    homeServicePriceList(){
      homeServicePriceList().then(({ data }) => {
        this.serverData = data.find((item) => item.id === this.$route.query.serviceId)
    })
    },
    // 再次支付获取服务信息
    async getSpeedOrderDetail(data){
      const price = window.localStorage.getItem('price')
      const consultType = window.localStorage.getItem('consultType')
      const serviceLengthUnit = window.localStorage.getItem('serviceLengthUnit')
      const showServiceLength = window.localStorage.getItem('showServiceLength')

        if(consultType==='2'){
          this.payInfo = {
            "serviceName":'图文咨询',
            "serviceCode":'ONE_TO_ONE',
            "servicePrice" : price,
            "originalPrice" : 0,
            "serviceLengthUnit" : serviceLengthUnit||"小时",
            "showServiceLength" : showServiceLength||12
          }
        }else if(consultType==='5'){
          this.payInfo = {
            "serviceName":'一对一电话咨询',
            "serviceCode":'ONE_TO_ONE_TEL',
            "servicePrice" : price,
            "originalPrice" : 0,
            "serviceLengthUnit" : serviceLengthUnit||"小时",
            "showServiceLength" : showServiceLength||12
          }
        }else{
          let resp = await speedOrderDetail(data)
          this.payInfo = resp.data
      }
    },
    // 已有订单号的再次下单支付
    async hasOrderAndPay(){
      let resp = await speedOrderGoPay(this.hasOrderPayQuery)
      window.location.href = JSON.parse(resp.data.payResultMsg).h5_url
    },
    /* 支付*/
    submitPay() {
        if (!this.checked) {
          this.$toast('请同意《服务购买协议》')
          return false
        } else {
          // 点击立即购买埋点
          this.config.code && buriedChannelPoint({
            code: this.config.code,
            type: BURY_POINT_TYPE.PAGE,
            behavior: BEHAVIOR.CK
          })
          // 1.5.1点击立即购买埋点 极速咨询支付页立即购买按钮点击
        //   buryPointChannelBasics({
        //     code: POINT_CODE.PUBLIC_PAY_PAY_PAGE_BUY_BUTTON,
        //     behavior: BURY_POINT_CHANNEL_TYPE.CA
        //   })
          // 流程更改 获取订单号或者订单id直接支付11
          this.hasOrderAndPay()
        }
    }
  }
}
</script>

<style scoped lang="scss">
.img-icon{
  width: 25px;
  height: 25px;
}
.pd-bm-10{
  padding-bottom: 10px;
}
.fixed-wrap{
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 35px;
}
.bt{
  width: 343px;
  height: 40px;
  margin: 50px auto 14px;
  line-height: 40px;
  text-align: center;
  background: #FFA700;
  border-radius: 20px;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
}
.pay-dialog{
   .van-dialog__header{
    font-size: 16px;
    color: #111111;
    font-weight: 600;
  }
  .van-dialog__content{
    padding-top: 8px;
    color: #6B6B6F;
    line-height: 24px;
    font-size: 15px;
  }
}
.findlawyer-order {
  min-height: 100vh;
  background: #F5F5F7;
}

.findlawyer-order-header {
  overflow: hidden;
  padding: 16px 16px 0;
  .title {
      height: 21px;
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #46474b;
      line-height: 21px;
  }
  .price{
    width: 343px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 0.2);
    box-sizing: border-box;
    margin: 18px 0;
    padding: 12px 12px 15px;
    img{
      width: 40px;
      height: 40px;
    }
    .mg2{
      margin: 4px;
    }
    .timer{
      height: 19px;
      padding: 0 10px;
      background: linear-gradient(90deg, #FFA700 0%, #FF883C 100%);
      border-radius: 10px;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 19px;
    }
  }

  .findlawyer-order-info {
    > div {
      height: 48px;
      border-bottom: 1px solid #ECECEC;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #46474B;
    }

    .date {
      font-size: 15px;
      font-weight: 600;
      color: #46474B;
    }

    .money {
      font-size: 15px;
      font-weight: 600;
      color: #4A549E;
    }
  }
}

.line {
  height: 40px;
  font-weight: bold;
  color: #46474B;
}
.origin-price{
   text-decoration: line-through;
}
.pay-type {
  margin-top: 13px;
  padding-bottom: 20px;
  .typeline{
    height: 50px;
    img{
      width: 24px;
      height: 24px;
    }
  }
  .tips{
    padding: 12px 0px 12px 10px;
    background-color: #F5F5F7;
    font-size: 11px;
    line-height: 18px;
    color: #8A8D94;;
    border-radius: 4px;
  }
  
  .check{
    width: 19px !important;
    height: 19px !important;
  }
  img {
    width: 32px;
    height: 32px;
  }

  p {
    padding-left: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #46474B;
  }

  i {
    font-size: 24px;
  }
}

.remarks {
  padding-top: 14px;
  align-items: center;

  .title {
    font-size: 14px;
    font-weight: 400;
    color: #46474B;
  }

    
}
::v-deep
  .van-checkbox__icon {
      height: 25px;
      line-height: 25px;
  }

.protocol {
  width: 100%;
  height: 30px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #8A8D94;
  background: #F5F5F7;
  padding-top: 8px;
  p {
    padding-left: 5px;
    display: flex;
    align-items: center;

    a {
      font-size: 12px;
      color: #2485FF;
      font-weight: 400;
    }
  }

//   /deep/ {
//     .van-checkbox {
//       border-radius: 2px;
//     }
//   }
}

.tip {
  font-size: 14px;
  background: #F5F5F7;
  font-weight: 400;
  color: #8A8D94;
  padding: 12px 16px 99px;
  text-align: justify;
}

.submit-order {
  padding: 0 16px;
  height: 49px;
  background: #FFFFFF;
  box-shadow: 0px -1px 0px 0px rgba(241, 241, 241, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .money {
    font-size: 13px;
    font-weight: 400;
    color: #666666;

    span {
      font-size: 16px;
      font-weight: 600;
      color: #4A549E;
    }
  }

  button {
    width: 160px;
    height: 40px;
    background: #4A549E;
    border-radius: 20px;
    border: none;
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
  }
}
</style>
